/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

// a Circle that grows on hover, opens a dropdown on click
export const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.primary};
  /* color: ${({ theme }) => theme.primary}; */
  font-weight: 500;
  font-size: 12px;
  font-family: "IBM Plex Mono";
  transition: all 150ms ease;
  /* fade in 2px black boarder on hover */
  &:hover {
    box-shadow: 0 0 0 0.7px ${({ theme }) => theme.primary};
  }
  /* grow on hover */
  &:hover {
    transform: scale(1.1);
  }
  /* grow on click */
  &:active {
    transform: scale(1.2);
  }
`;

export const CircleWrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  position: relative;
  top: 1px;
`;
